export const SENIOR_IDS = ['michael', 'ana', 'buggie', 'leslie', 'lana', 'victor', 'eegi', 'mayara', 'rino', 'salome'];

const CLAREHALL_RATES = { '30 mins': 80, '45 mins': 100, '1 hour': 130, '1 hr 30 mins': 160, '2 hours': 240 };

export const calcPersonPrice = (service, location, therapistId) => {
  const basePrice = service?.price || 0;
  const name = service?.name?.toLowerCase() || '';
  if (name.includes('reflexology') || name.includes('senior')) return basePrice;
  if (location === 'clarehall') return CLAREHALL_RATES[service?.duration] ?? basePrice;
  return basePrice;
};
